import styled from 'styled-components';

export const Container = styled.button<{ active: boolean; disableBorder?: boolean }>`
  background-color: ${(props) => (props.active ? props.theme.backgroundLightest : props.theme.background)};
  border: 1px solid ${(props) => props.theme.keyline};
  height: 56px;
  display: flex;
  flex-direction: row;
  padding: 14px 10px;
  flex: 1;
  align-items: center;

  ${(props) =>
    props.disableBorder &&
    `
    border: none;
    border-radius: 4px;
  `}
`;

export const Text = styled.span`
  flex: 1;
  font-weight: 600;
  color: ${(props) => props.theme.textDark};
  font-size: 14px;
  text-align: left;
  padding-left: 10px;
`;
